import type { Dispatch, SetStateAction } from "react";
import PdfPage from "../../../components/documentsViewer/PdfPage";
import InfoConfigContainer from "../../../components/InfoConfigContainer/InfoConfigContainer";
import {
  BoldText,
  CheckListContainer,
  PdfViewer,
  ScriptColumn,
  Wrapper
} from "../manual-check-final/disbursementCheckStyles";
import { Checklist } from "./checklist";

interface InfoConfigProps {
  checklistValues: string[];
  setChecklistValues: Dispatch<SetStateAction<string[]>>;
}
export const infoConfig = ({
  checklistValues,
  setChecklistValues
}: InfoConfigProps) => {
  return [
    {
      component: (
        <>
          <InfoConfigContainer title="Final Disbursement Check Script">
            <Wrapper>
              <CheckListContainer>
                <Checklist
                  checklistValues={checklistValues}
                  setChecklistValues={setChecklistValues}
                />
              </CheckListContainer>
              <ScriptColumn>
                <BoldText>Script</BoldText>
                <PdfViewer>
                  <PdfPage
                    pdfPath="/Disbursement.check.script.pdf"
                    scale={1}
                    width={500}
                  />
                </PdfViewer>
              </ScriptColumn>
            </Wrapper>
          </InfoConfigContainer>
        </>
      ),
      order: 1
    }
  ];
};
